module.exports = __webpack_public_path__ + "img/uid-token-btn .5cb43997.png";